import { App, Button, Card, Empty, Popconfirm, Space, Spin, Tag, Typography } from 'antd';
import { DeleteOutlined, HighlightOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { PageHero } from '@/components/PageHero';
import { useFlyerDocs, useDeleteFlyerDoc } from '@/hooks/useFlyerDocs';

export function ComposeListPage() {
  const { message } = App.useApp();
  const nav = useNavigate();
  const docsQ = useFlyerDocs();
  const del = useDeleteFlyerDoc();

  return (
    <div style={{ maxWidth: 1200 }}>
      <PageHero icon={<HighlightOutlined />} title="Flyer Composer" subtitle="Finished flyers — edit, localize, export back to programs" />
      <Space style={{ marginBottom: 12, width: '100%', justifyContent: 'flex-end' }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => nav('/flyers/compose/new')}>New document</Button>
      </Space>
      {docsQ.isLoading ? <Spin /> : (docsQ.data ?? []).length === 0 ? <Empty description="No documents" /> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
          {(docsQ.data ?? []).map((d) => (
            <Card key={d.id} size="small" hoverable onClick={() => nav(`/flyers/compose/${d.id}`)}>
              <Typography.Text strong ellipsis style={{ display: 'block' }}>{d.name}</Typography.Text>
              <Space style={{ marginTop: 6, width: '100%', justifyContent: 'space-between' }}>
                <Space size={4}>
                  <Tag>{d.lang}</Tag>
                  {d.source_topic_no && <Tag color="cyan">program {d.source_topic_no}</Tag>}
                  {d.exports_json && Object.keys(d.exports_json).map((l) => <Tag key={l} color="green">{l} ✓</Tag>)}
                </Space>
                <Popconfirm title={d.exports_json && Object.keys(d.exports_json).length > 0
                  ? `Delete "${d.name}"? Its exported flyers (${Object.keys(d.exports_json).join(', ')}) are linked from the program and will stop working.`
                  : `Delete "${d.name}"?`}
                  onConfirm={(e) => { e?.stopPropagation(); del.mutate(d.id, { onError: (err) => message.error(err.message) }); }}
                  onCancel={(e) => e?.stopPropagation()}>
                  <Button size="small" danger icon={<DeleteOutlined />} onClick={(e) => e.stopPropagation()} />
                </Popconfirm>
              </Space>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
